import Repo from './Repo.js'

export default class TravelWarrantSuggestionRepository extends Repo {
  constructor () {
    super('travel-warrant-suggestions')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
      return super.paginate(q)
  }

  search (data) {
    return super.search(data)
  }

  declineAll (data) {
    return this.http.post(this.resource + '/decline', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  approveAll (data) {
    return this.http.post(this.resource + '/approve', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  pair (data) {
    return this.http.post(this.resource + '/pair', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }




}
